const routes = {

  home: "/",
  login: "/login",
 signup:"/signup",
 job:'/job',
 candidates:"/candidates",
 profile:'/profile',
 contact:'/contact',
 about:'/about'
};

export default routes;
